module.exports = __webpack_public_path__ + "1b61999f5717b36d796672ad6ca8c0a1.pdf";